var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_936_2995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.14543 15.8094L8.08594 13.2443L13.0264 15.8094L12.1131 10.3174L16.0798 6.41128L10.5746 5.58355L8.08594 0.604858L5.59727 5.58355L0 6.41128L4.05878 10.3174L3.14543 15.8094Z",
    fill: "#5BA1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.14543 30.6336L8.08594 28.0686L13.0264 30.6336L12.1131 25.1416L16.0798 21.2355L10.5746 20.4078L8.08594 15.4291L5.59727 20.4078L0 21.2355L4.05878 25.1416L3.14543 30.6336Z",
    fill: "#5BA1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.14543 45.3959L8.08594 42.8928L13.0264 45.3959L12.1131 39.9659L16.0798 36.0597L10.5746 35.232L8.08594 30.2533L5.59727 35.232L0 36.0597L4.05878 39.9659L3.14543 45.3959Z",
    fill: "#5BA1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8672 34.6147H27.043V42.7007H18.8672V34.6147Z",
    fill: "#5BA1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8672 4.96631H46V13.0522H18.8672V4.96631Z",
    fill: "#5BA1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8672 19.7905H35.1289V27.8765H18.8672V19.7905Z",
    fill: "#5BA1FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_936_2995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRating);
export default __webpack_public_path__ + "static/media/icon-rating.5262fd23.svg";
export { ForwardRef as ReactComponent };